import Vue from 'vue'
import './assets/scss/main.scss'

//NIMBLE
import Nimble from 'nimble-cashforce'
import 'nimble-cashforce/dist/nimble-cashforce.css'

import VueTheMask from 'vue-the-mask'
import vueAwesomeCountdown from 'vue-awesome-countdown'
import VCalendar from 'v-calendar'
import App from './App.vue'
// require('dotenv').config()
import router from './router'
import store from './store'
import formatCnpjOrCpf from '@/filters/formatCnpjOrCpf'
import formatMoney from '@/filters/formatMoney'
import formatDate from '@/filters/formatDate'
import formatDateHour from '@/filters/formatDateHour'
import formatName from '@/filters/formatName'
import formatPhone from '@/filters/formatPhone'
import formatNumberWithZero from '@/filters/formatNumberWithZero'
import formatDateHourWithoutYear from '@/filters/formatDateHourWithoutYear'
import whitelabel from '@/mixins/whitelabel'
import users from '@/mixins/users'
import capitalizeFirstLetter from '@/filters/capitalizeFirstLetter'
import filter from '@/mixins/filter'

import VueGtm from "vue-gtm"

Vue.use(VueGtm, {
    id: "GTM-NCWKG8T",
    defer: false,
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: router,
    ignoredViews: [],
    trackOnNextTick: false,
})

Vue.use(Nimble)
Vue.use(VueTheMask)
Vue.use(vueAwesomeCountdown, 'vac')
Vue.use(VCalendar, { componentPrefix: 'vc' })
Vue.use(formatCnpjOrCpf)
Vue.use(formatMoney)
Vue.use(formatDate)
Vue.use(formatDateHour)
Vue.use(formatName)
Vue.use(formatPhone)
Vue.use(formatNumberWithZero)
Vue.use(formatDateHourWithoutYear)
Vue.use(whitelabel)
Vue.use(users)
Vue.use(capitalizeFirstLetter)
Vue.use(filter)

Vue.config.productionTip = true

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')